module.exports = __webpack_public_path__ + "img/Download.814858d9.svg";